export let getBlobForArrayBuffer: (arrayBuffer: ArrayBuffer) => Blob;
export let getArrayBufferForBlob: (Blob: Blob) => ArrayBuffer;

export const getBrowserName = () => {
  // Opera 8.0+
  const isOpera =
    (!!window.opr && !!opr.addons) ||
    !!window.opera ||
    navigator.userAgent.indexOf(' OPR/') >= 0;
  if (isOpera) return 'opera';
  // Firefox 1.0+
  const isFirefox = typeof window.InstallTrigger !== 'undefined';

  if (isFirefox) return 'firefox';

  // Safari 3.0+ "[object HTMLElementConstructor]"
  const isSafari =
    /constructor/i.test(window.HTMLElement) ||
    (function (p) {
      return p.toString() === '[object SafariRemoteNotification]';
    })(
      !window['safari'] ||
        (typeof window.safari !== 'undefined' &&
          window['safari'].pushNotification),
    );

  if (isSafari) return 'apple-safari';

  // Internet Explorer 6-11
  const isIE = /*@cc_on!@*/ false || !!window.document.documentMode;

  if (isIE) return 'microsoft-internet-explorer';
  // Edge 20+
  const isEdge = !isIE && !!window.StyleMedia;

  if (isEdge) return 'microsoft-edge';

  // Chrome 1 - 79
  const isChrome = window.chrome;

  if (isChrome) return 'google-chrome';

  // Edge (based on chromium) detection
  const isEdgeChromium =
    window.isChrome &&
    window.navigator.userAgent.indexOf('Edg') != -1;

  if (isEdgeChromium) return 'microsoft-edge';

  // Blink engine detection
  const isBlink = (window.isChrome || isOpera) && !!window.CSS;

  if (isBlink) return 'blink';
};

const units = [
  'bytes',
  'KiB',
  'MiB',
  'GiB',
  'TiB',
  'PiB',
  'EiB',
  'ZiB',
  'YiB',
];
export const niceBytes = (x: string) => {
  let l = 0,
    n = parseInt(x, 10) || 0;

  while (n >= 1024 && ++l) {
    n = n / 1024;
  }

  return n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l];
};

export async function getBase64(file: File) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      // console.log(reader.result);
      resolve(reader.result);
    };
    reader.onerror = function (error) {
      console.error('Error: ', error);
      reject(error);
    };
  });
}

export async function initNativeBlobMethods() {
  const jsi = await import('react-native-blob-jsi-helper');
  getBlobForArrayBuffer = jsi.getBlobForArrayBuffer;
  getArrayBufferForBlob = jsi.getArrayBufferForBlob;
}
